module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-35.07f9f7eb.png";